import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCloud = () => {
  return (
    <g>
      <path d="M8 1c3.176 0 5.75 2.569 5.75 5.737 0 .357-.033.709-.097 1.052A3.742 3.742 0 0 1 16 11.259c0 2-1.573 3.633-3.553 3.736l-.2.005h-7.25C2.243 15 0 12.89 0 10.26c0-1.665.904-3.123 2.267-3.968A5.745 5.745 0 0 1 8 1zm0 1.497a4.25 4.25 0 0 0-4.106 3.142 5.05 5.05 0 0 1 .593-.093l.1-.005.49-.011.926-.009a.75.75 0 1 1 0 1.497l-.974.016-.45.016-.171.014c-1.657.263-2.907 1.602-2.907 3.197 0 1.722 1.451 3.145 3.302 3.238l.193.004h7.252a2.248 2.248 0 0 0 2.251-2.245c0-.89-.525-1.681-1.313-2.041a5.738 5.738 0 0 1-1.298 1.747.751.751 0 0 1-1.06-.045.747.747 0 0 1 .045-1.057 4.222 4.222 0 0 0 1.377-3.125A4.245 4.245 0 0 0 8 2.497z" />
    </g>
  );
};

export default withIcon(IconCloud);
